var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWelcomeEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 67,
    viewBox: "0 0 69 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.331 16.543c-1.606.255-4.384 1.793-5.289 4.796-.175.582-.366 1.1-.552 1.563-1.828 4.561-3.693 3.187-5.056.029-2.893-6.699-5.369-12.799-5.369-12.799-1.143-2.28-2.986-1.41-3-1.406-1.216.5-1.423 1.718-.939 2.954l4.923 14.462-.146.079-7.484-16.2c-.538-1.309-1.715-1.832-2.73-1.416-1.015.416-1.485 1.614-.947 2.922l6.37 17.272-.132.07-7.195-14.382c-.605-1.278-1.8-1.761-2.776-1.3-.973.46-1.358 1.689-.753 2.967l6.708 16.404-.104.056-5.857-10.85c-.64-1.261-1.951-1.881-2.948-1.375-.998.507-1.269 1.93-.627 3.19 0 0 5.306 13.255 8.547 17.858 3.616 5.135 9.33 6.945 14.886 4.545 7.443-3.278 8.43-9.044 8.775-11.101.234-1.148.347-2.227.349-3.153l-.003-.002c.013-.227.025-.46.032-.657.168-4.88 1.025-7.769 3.008-10.483 1.983-2.714-.085-4.298-1.69-4.043Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-18.829 77.286 -25.56) skewX(.04)",
    fill: "url(#c)",
    d: "M0 0h36.2v28.977H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-18.829 110.645 -38.937) skewX(.041)",
    fill: "url(#d)",
    d: "M0 0h15.454v16.532H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-18.829 88.283 -70.438) skewX(.041)",
    fill: "url(#e)",
    d: "M0 0h19.964v20.74H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 25,
    width: 24,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.558 34.646c-6.028 2.578-9.218 9.078-11.078 4.738-1.86-4.34 1.532-9.969 7.56-12.547 6.028-2.578 12.445-1.145 14.305 3.195 1.86 4.34-4.759 2.036-10.787 4.614Z",
    fill: "url(#f)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.916 8.243a.624.624 0 0 0-.03.88c1.322 1.435 2.317 3.685 2.784 6.295.06.35.399.573.723.519l.053-.013a.628.628 0 0 0 .46-.736c-.54-2.9-1.596-5.275-3.11-6.915a.626.626 0 0 0-.88-.03ZM38.253 7.311a.626.626 0 0 0-.88-.029.625.625 0 0 0-.03.88c1.368 1.508 2.39 3.863 2.836 6.618.061.35.373.58.724.52l.052-.014a.625.625 0 0 0 .467-.71c-.507-2.992-1.641-5.572-3.17-7.265ZM6.948 24.621a.636.636 0 0 0-.72-.517.636.636 0 0 0-.518.72c.538 2.889 1.588 5.256 3.097 6.89a.598.598 0 0 0 .607.181.62.62 0 0 0 .27-.152.622.622 0 0 0 .029-.877c-1.31-1.404-2.294-3.619-2.765-6.245ZM4.453 25.282a.618.618 0 0 0-.72-.517.617.617 0 0 0-.518.72c.48 2.987 1.61 5.558 3.16 7.237a.598.598 0 0 0 .606.182.62.62 0 0 0 .27-.152.622.622 0 0 0 .03-.876c-1.39-1.496-2.382-3.85-2.828-6.594Z",
    fill: "#2FAEF3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "e",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("image", {
    id: "h",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAloAAAHiCAYAAAAwKmJvAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "i",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQEAAAETCAYAAAA28rNtAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "j",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUwAAAFZCAYAAADzdRZ3AAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2.894,
    y1: 11.74,
    x2: 50.121,
    y2: 38.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#FFD510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 31.544,
    y1: 34.897,
    x2: 23.7,
    y2: 22.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.368
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.081,
    y: 0.465,
    width: 67.939,
    height: 66.531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWelcomeEmoji);
export default __webpack_public_path__ + "static/media/icon-welcome-emoji.f49bf517720795712225439e18d98cf5.svg";
export { ForwardRef as ReactComponent };